/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import React from "react";
import { Text, BackgroundPanel } from "vr-react-components";
import BarWidgetTooltip from "../../../widgets/BarWidget/BarWidgetTooltip";
import LeftPanelDesktop from "./LeftPanelDesktop";
import RightPanelDesktop from "./RightPanelDesktop";
import CenterChart from "../../../components/CenterChart";

const DesktopRoom = () => {
    const title = "Workload VR Console";

    return (
        <a-entity class="Home Room">
            <Text align="left" position="-2.65 3 -1.8" width="2" size="p4" text={title} />
            <a-entity id="right-panel" position="2 1.7 -1.8">
                <RightPanelDesktop width={1.6} height={2.3} />
            </a-entity>
            <a-entity id="left-panel" position="-2 1.7 -1.8">
                <LeftPanelDesktop width={1.6} height={2.3} />
            </a-entity>
            <BackgroundPanel width={2.2} height={0.5} position={`0 2.6 -1.8`}>
                <Text
                    text="3D Data Visualization"
                    width={2}
                    sizeDecimal={20}
                    position="-1.05 0.22 0"
                    baseline="top"
                />
                <BarWidgetTooltip
                    width={2.15}
                    height={0.35}
                    stateName="centerGraph"
                    position="0 -0.05 0.001"
                    backgroundColor="#262626"
                />
            </BackgroundPanel>
            <a-entity position="0 0.8 -3">
                <CenterChart width={3} height={2} depth={2} />
            </a-entity>
        </a-entity>
    );
};

export default DesktopRoom;